export var selectedNode = function selectedNode(_ref) {
  var selectedNode = _ref.selectedNode;
  return selectedNode;
};
export var wikiMeta = function wikiMeta(_ref2) {
  var wikiMeta = _ref2.wikiMeta;
  return wikiMeta;
};
export var nodesTreeView = function nodesTreeView(_ref3) {
  var nodesTreeView = _ref3.nodesTreeView;
  return nodesTreeView;
};
export var deletedCategory = function deletedCategory(_ref4) {
  var deletedCategory = _ref4.deletedCategory;
  return deletedCategory;
};
export var historyCategory = function historyCategory(_ref5) {
  var historyCategory = _ref5.historyCategory;
  return historyCategory;
};
export var categoryDeleteGlobally = function categoryDeleteGlobally(_ref6) {
  var categoryDeleteGlobally = _ref6.categoryDeleteGlobally;
  return categoryDeleteGlobally;
};
export var isDeletingGloballyActive = function isDeletingGloballyActive(_ref7) {
  var isDeletingGloballyActive = _ref7.isDeletingGloballyActive;
  return isDeletingGloballyActive;
};